<template>
 <router-view></router-view>
 <HelpDrawer />
 <UpdateBanner />
 <MaintenanceBanner />
 <AiAssistantPanel v-if="isAiUser" />
</template>

<script>
import HelpDrawer from '@/components/help-drawer.vue';
import UpdateBanner from '@/components/update-banner.vue';
import MaintenanceBanner from '@/components/maintenance-banner.vue';
import AiAssistantPanel from '@/components/ai-assistant-panel.vue';
import { aiAssistantOpen } from '@/helpers/aiAssistant';
import { startMaintenancePolling, stopMaintenancePolling, refreshMaintenance } from '@/helpers/maintenance';

export default {
  name: 'App',
  components: { HelpDrawer, UpdateBanner, MaintenanceBanner, AiAssistantPanel },
  computed: {
    isAuthenticated() {
      return Boolean(this.$store.getters['auth/isApiAuthenticated']);
    },
    // KI-Assistent (Experiment) nur für den Login-User «imi».
    isAiUser() {
      return String(this.$store.state?.auth?.apiCurrentUser?.username || '').trim().toLowerCase() === 'imi';
    },
    // Stream nur für Sessions öffnen, die ihn nutzen dürfen — sonst droht
    // über die Reconnect-Eskalation ein Force-Logout.
    canUseSseStream() {
      const getters = this.$store.getters;
      return Boolean(getters['auth/isApiAuthenticated']
        && (getters['auth/canAccessVm'] || getters['auth/canAccessAdmin']));
    },
  },
  watch: {
    // Beim Logout/User-Wechsel Panel schliessen (Body-Klasse wird im Panel entfernt).
    isAiUser(allowed) {
      if (!allowed) {
        aiAssistantOpen.value = false;
        document.body.classList.remove('ai-assistant-open');
      }
    },
    // Nach Login/Logout sofort neu laden: angemeldet kommen Clusternamen dazu, abgemeldet fallen sie weg.
    isAuthenticated(authenticated, wasAuthenticated) {
      if (authenticated !== wasAuthenticated) refreshMaintenance();
    },
    // App-weiter SSE-Stream: einmal starten, Reconnect übernimmt der Store.
    canUseSseStream: {
      immediate: true,
      handler(canUse) {
        if (canUse) this.$store.dispatch('virtualInfrastructure/startSseStream');
      },
    },
  },
  mounted() {
    startMaintenancePolling();
    this.$store.dispatch('virtualInfrastructure/initRuntimeGuards');
  },
  beforeUnmount() {
    stopMaintenancePolling();
    this.$store.dispatch('virtualInfrastructure/stopRuntimeGuards');
  },
}
</script>
